import { MapPin, Heart, PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost1 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;
  
  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Main content - centered for safe zone */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          padding: "100px",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: "160px",
            height: "160px",
            background: "linear-gradient(135deg, #5D9A7D 0%, #4E8A6E 100%)",
            borderRadius: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "48px",
            boxShadow: "0 12px 40px rgba(78,138,110,0.35)",
          }}
        >
          <MapPin style={{ width: "88px", height: "88px", color: "#FFFFFF" }} />
        </div>

        <h1
          style={{
            fontSize: "84px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 24px",
            lineHeight: 1.1,
          }}
        >
          Mapa Schronisk<br />dla Zwierząt
        </h1>

        <p
          style={{
            fontSize: "40px",
            color: "#4A7A5E",
            margin: "0 0 56px",
            fontWeight: 600,
            lineHeight: 1.3,
          }}
        >
          Znajdź schronisko blisko siebie<br />
          i dowiedz się, jak możesz pomóc
        </p>

        {/* Features row */}
        <div
          style={{
            display: "flex",
            gap: "24px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          {["Aktualne potrzeby", "Wolontariat", "Spacery z psami"].map((text) => (
            <div
              key={text}
              style={{
                background: "rgba(255,255,255,0.95)",
                padding: "20px 36px",
                borderRadius: "50px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
              }}
            >
              <Heart style={{ width: "28px", height: "28px", color: "#4E8A6E" }} />
              <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
                {text}
              </span>
            </div>
          ))}
        </div>

        {/* Logo with brand name */}
        <div
          style={{
            marginTop: "56px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "36px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>
      </div>
    </GraphicBackground>
  );
};

